/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-02-21 15:05:31
 * @FilePath: /m-anquan-baidu-com/src/containers/apply/index.js
 * @Description: 申请试用页面
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {List, InputItem, TextareaItem} from 'antd-mobile';
import {fetchCmsapiIndexData, fetchUserApply} from '../../actions/applyAction';

import './index.less';

class Apply extends Component {
    static propTypes = {
        fetchCmsapiIndexData: PropTypes.func,
        fetchUserApply: PropTypes.func,
        userApplyData: PropTypes.object,
        cmsapiUserapply: PropTypes.object,
        userLoginstate: PropTypes.object,
        match: PropTypes.object
    };

    /**
     * 构造函数，初始化状态和属性
     * @param {Object} props React组件属性，包含match对象
     * @param {Object} context React组件上下文对象
     */
    constructor(props, context) {
        super(props, context);
        this.state = {
            overallTypeIndex: 2,    // 身份类型
            probationIndex: 2, // 是否试用
            enterpriseName: '',  // 企业名称
            codeVal: '',
            enterpriseNameError: false,
            userNameError: false,
            codeError: false,
            userName: '',   // 真实姓名
            hasError: false,
            userPhoneVal: '', // 电话号码
            workId: [this.props.match.params.Iid], // 感兴趣的业务
            overallTextarea: '', // 咨询内容
            userPhoneError: false,
            desInfoError: false,
            userPhoneErrorHint: '手机号码不能为空',
            userEmailError: false,
            userEmailErrorHint: '联系邮箱不能为空',
            codeImg: '/catpcha',
            codeHint: '验证码不能为空',
            from: this.getRequest().from
        };
        this.overallType = [
            {val: '企业', id: 2},
            {val: '个人', id: 1}
        ];
        this.probation = [
            {val: '需要', id: 2},
            {val: '不需要', id: 1}
        ];
    }

    /**
     * 组件将要挂载时调用，判断是否为pc端，如果是则重定向到对应的页面
     */
    componentWillMount() {
        if (this.isPC()) {
            let str = '/?showForm=open';
            let Iid = this.props.match.params.Iid;
            let from = this.state.from;


            if (Iid) {
                str = `/page/${Iid}?showForm=open`;
            }

            if (Iid && from) {
                str = `/page/${Iid}?showForm=open&from=${from}`;
            }

            if (!Iid && from) {
                str = `/?showForm=open&from=${from}`;
            }
            location.href = str;
        }
    }

    /**
     * @function componentDidMount
     * @description 在组件挂载后，根据路由参数获取工作ID，并设置textarea的值为对应的导航名称。如果没有路由参数，则从服务列表中查询工作ID对应的导航名称，并设置textarea的值为对应的导航名称。
     */
    componentDidMount() {
        const name = this.getParams().name;

        if (name) {
            this.setState({overallTextarea: name});
            return;
        }
        this.props.fetchCmsapiIndexData().then(() => {
            const itemlist = this.props.userApplyData.itemlist;
            let workId = this.state.workId[0];

            itemlist.service_list.forEach(item => {
                if (workId === item.id) {
                    this.setState({
                        overallTextarea: `#${item.navigation_name}#`
                    });
                }
            });
        });
    }

    userPhoneChange = val => {
        let fruit = false;
        let hint = '';
        if (this.isEmpty(val)) {
            hint = '电话号码不能为空';
            fruit = this.isEmpty(val);
        } else if (!this.isPhone(val)) {
            hint = '电话号码格式不正确，请确认';
            fruit = !this.isPhone(val);
        }
        this.setState({
            userPhoneError: fruit,
            userPhoneVal: val,
            userPhoneErrorHint: hint
        });
        return !fruit;
    };

    submitFun = () => {
        let {
            overallTypeIndex,
            probationIndex,
            enterpriseName,
            userName,
            userPhoneVal,
            overallTextarea,
            codeVal,
            from
        } = this.state;
        this.setState({
            enterpriseNameError: this.isEmpty(enterpriseName),
            userNameError: this.isEmpty(userName),
            codeError: this.isEmpty(codeVal),
            codeHint: this.isEmpty(codeVal) ? '验证码不能为空' : ''
        });
        this.userPhoneChange(userPhoneVal);
        if (!this.isEmpty(userName)
            && this.userPhoneChange(userPhoneVal)
            && !this.isEmpty(codeVal)) {

            if (overallTypeIndex === 2) {
                if (this.isEmpty(enterpriseName)) {
                    return;
                }
            }

            let json = {
                'company_name': enterpriseName,
                'real_name': userName,
                'phone_number': userPhoneVal.replace(/\s+/g, ''),
                'id_type': overallTypeIndex,
                'note': this.props.match.params.Iid === '1' ? probationIndex === 2 ? '需要试用' + overallTextarea
                    : '不需要需要试用' + overallTextarea : overallTextarea,
                'catpcha': codeVal,
                'from': from
            };
            if (overallTypeIndex === 1) {
                delete json['company_name'];
            }
            this.props.fetchUserApply(json).then(() => {
                const cmsapiUserapply = this.props.cmsapiUserapply;
                if (location.href.indexOf('testError') !== -1) {
                    alert(cmsapiUserapply.msg);
                }
                if (cmsapiUserapply.is_error === 0) {
                    if (this.isPageTitle('mesatee', this.state.overallTextarea)) {
                        this.reportData('mesatee_submit');
                    }
                    let isLlmsec = location.href.includes('/m/apply/77');
                    setTimeout(() => {
                        if (from) {
                            location.href = `/m/apply-succ?from=${from}`;
                        } else {
                            location.href = `/m/apply-succ?isLlmsec=${isLlmsec}`;
                        }
                    }, 100);
                }

                if (cmsapiUserapply.is_error === 3) {
                    this.setState({
                        codeError: true,
                        codeHint: '验证码不正确',
                        codeImg: `/catpcha?t=${Date.now()}`
                    });
                }
            });
        }
    };

    isEmpty = val => {
        let reg = /\S/;
        return !reg.test(val);
    };

    isEmail = val => {
        let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        let value = val.replace(/\s/g, '');
        return reg.test(value);
    };

    /**
     * @description 主要功能函数，返回一个React元素列表，包括输入框、文本区域等。
     * 如果路由参数中有Iid=1，则显示“申请试用”相关信息；否则只显示基本信息。
     * 对于输入框，需要判断是否为必填项，并在失去焦点时进行校验，错误时添加样式，同时显示错误提示。
     * 对于文本区域，也需要进行校验，错误时添加样式，同时显示错误提示。
     * 对于验证码，需要使用图片验证码，当点击图片验证码时，重新获取验证码，并将验证码值清空。
     * 最后，提交按钮的事件处理器应该调用submitFun函数。
     * @param {Object} props - React组件属性，包含match对象，match对象中包含了路由参数Iid，可以根据这个参数来判断是否显示“申请试用”相关信息。
     * @returns {Array.<JSX.Element>} 返回一个React元素列表，包括输入框、文本区域等。
     */
    render() {
        let {
            overallTypeIndex,
            probationIndex,
            enterpriseNameError,
            overallTextarea,
            userNameError,
            codeError,
            userPhoneError,
            userEmailError,
            userPhoneErrorHint,
            userEmailErrorHint,
            codeHint,
            codeImg
        } = this.state;

        let enterpriseClass = classnames({
            'input-disable': overallTypeIndex === 1,
            'on': enterpriseNameError && overallTypeIndex !== 1
        });

        return (
            <div className={'apply'}>
                <h2>
                    {
                        this.props.match.params.Iid === '1' ? '业务咨询 申请试用' : '业务咨询'
                    }
                </h2>
                <div className={'spu-apply-from'}>
                    <form>
                        {
                            this.props.match.params.Iid === '1'
                                ? <List>
                                    <div className={'apply-form-title'}>
                                        请留下您的联系方式，百度安全给您提供专业方案
                                    </div>
                                </List> : ''
                        }

                        <List>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 身份类型：
                            </div>
                            <div className={'apply-form-assist'}>
                                {this.overallType.map((item, index) => {
                                    return <div
                                        className={'overall-type-box'}
                                        key={index}
                                        onClick={() => {
                                            this.setState({
                                                overallTypeIndex: item.id
                                            });
                                        }}
                                    >
                                        <span className={overallTypeIndex === item.id ? 'on' : ''}></span>
                                        <span>{item.val}</span>
                                    </div>;
                                })
                                }
                            </div>
                        </List>

                        {
                            this.props.match.params.Iid === '1'
                                ? <List>
                                    <div className={'apply-form-title'}>
                                        <span className={'hint-star'}>*</span> 是否申请试用：
                                    </div>
                                    <div className={'apply-form-assist'}>
                                        {this.probation.map((item, index) => {
                                            return <div
                                                className={'overall-type-box'}
                                                key={index}
                                                onClick={() => {
                                                    this.setState({
                                                        probationIndex: item.id
                                                    });
                                                }}
                                            >
                                                <span className={probationIndex === item.id ? 'on' : ''}></span>
                                                <span>{item.val}</span>
                                            </div>;
                                        })
                                        }
                                    </div>
                                </List> : ''
                        }

                        <List className={enterpriseClass}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 企业名称：
                            </div>
                            <InputItem
                                placeholder="请输入真实企业名称"
                                disabled={overallTypeIndex === 1}
                                onBlur={val => {
                                    this.setState({
                                        enterpriseName: val
                                    });
                                }}

                            />
                            <div className={'apply-error-hint'}>企业名称不能为空</div>
                        </List>

                        <List className={userNameError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 真实姓名：
                            </div>
                            <InputItem
                                placeholder="请输入真实姓名便于联系"
                                onBlur={val => {
                                    this.setState({
                                        userName: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>真实姓名不能为空</div>
                        </List>

                        <List className={userPhoneError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 电话号码：
                            </div>
                            <InputItem
                                type={'phone'}
                                placeholder="请输入真实电话号码便于联系"
                                onChange={val => {
                                    this.setState({
                                        userPhoneVal: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>
                                {userPhoneErrorHint}
                            </div>
                        </List>

                        <List>
                            <div className={'apply-form-title'}>
                                咨询内容：
                            </div>
                            <TextareaItem
                                placeholder={'请描述您想咨询的内容'}
                                value={overallTextarea}
                                onChange={val => {
                                    this.setState({
                                        overallTextarea: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}></div>
                        </List>

                        <List className={codeError ? 'codeInput on' : 'x'}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 验证码：
                            </div>
                            <InputItem
                                placeholder="请输出右侧验证码"
                                onChange={val => {
                                    this.setState({
                                        codeVal: val,
                                        codeError: !val.replace(/\s+/g, '')
                                    });
                                }}
                            />
                            <div
                                className="overall-code"
                                onClick={() => {
                                    this.setState({
                                        codeImg: ''
                                    }, () => {
                                        this.setState({
                                            codeImg: '/catpcha'
                                        });
                                    });
                                }}
                            >
                                <img src={codeImg} alt="" height="100%" />
                            </div>
                            <div className={'apply-error-hint'}>
                                {codeHint}
                            </div>
                        </List>

                    </form>
                </div>
                <div className={'apply-subbtn'} onClick={this.submitFun}>
                    提交
                </div>
            </div>
        );
    }
}

/**
 * @description 将redux的state映射到组件的props中，包含用户登录状态、用户申请数据和CMSAPI获取的用户申请信息等
 * @param {Object} state redux的state对象，包含多个reducer的state
 * @returns {Object} 返回一个包含多个属性的对象，每个属性都是redux的state中的一个属性，如{userLoginstate, userApplyData, cmsapiUserapply}
 */
function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        userApplyData: state.userApplyData,
        cmsapiUserapply: state.cmsapiUserapply
    };
}

/**
 * @param {Function} dispatch - redux的dispatch函数，用于触发action
 * @returns {Object} - 包含了一些方法的对象，每个方法都是一个thunk，返回一个promise，可以在这里处理异步操作
 * fetchCmsapiIndexData：获取首页数据的action，参数为dispatch
 * fetchUserApply：提交申请的action，参数为{obj}，其中obj包含{name, phone, email, content}等字段
 */
function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiIndexData: () => fetchCmsapiIndexData(dispatch),
        fetchUserApply: obj => fetchUserApply(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Apply);



// WEBPACK FOOTER //
// ./src/containers/apply/index.js